import { SHOW_POPUP, HIDE_POPUP } from '../actions/popup';

let initialState = {
  popupData: false,
};

const popup = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_POPUP:
      return {
        ...state,
        popupData: action.payload,
      };

    case HIDE_POPUP:
      return {
        ...state,
        popupData: null,
      };

    default:
      return state;
  }
};

export default popup;
